export default "__VITE_ASSET__DAjMNqKJ__"